export interface RatesRejectedCountry {
  code: string;
  label: string;
}

export interface RatesRejectedCountriesResponse {
  rejectedCountries: RatesRejectedCountry[];
  totalRejected: number;
  totalChecked?: number;
}
